module.exports = {
    i18n: {
        localeDetection: false,
        defaultLocale: 'en',
        locales: [
            'en',
            'de',
            'en-US',
            'de-DE',
            'en-DE',
            'en-AU',
            'en-CA',
            'en-GB',
        ],
        domains: [
            {
                domain: 'vivosun.de',
                defaultLocale: 'en-US',
            },
            {
                domain: 'vivosun.ca',
                defaultLocale: 'en-CA',
            },
        ],
    },
    async rewrites() {
        return [
            {
                source: '/:path([^\\/]*-[ac]\\d+)*',
                destination: '/list/:path*',
            },
            {
                source: '/:path([^\\/]*-p\\d+)*',
                destination: '/products/:path*',
            },
            {
                source: '/:path([^\\/]*-p\\d+-v\\d+)*',
                destination: '/products/:path*',
            },
            {
                source: '/shop',
                destination: '/',
            },
            {
                source: '/diy-pools',
                destination: '/diy-pool',
            },
            {
                source: '/vivosun-smart-grow-box',
                destination: '/brochure/vivosun-smart-grow-box',
            },
            {
                source: '/crowd-funding/:code*',
                destination: '/crowdfunding/:code*',
            },
        ]
    },
    async redirects() {
        return [
            {
                source: '/cyber-monday',
                destination: '/weekly-deal',
                permanent: true,
            },
            {
                source: '/black-friday',
                destination: '/weekly-deal',
                permanent: true,
            },
        ]
    }
}